import { faEllipsisVertical, faPen, faPlus, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';
import { PackagingItem } from '../../models/Packaging';

interface DropdownActionsProps {
  item: PackagingItem;
  onEdit?: (item: PackagingItem) => void;
  onDelete?: (item: PackagingItem) => void;
  onAdjustStock?: (item: PackagingItem) => void;
}

export const DropdownActions = ({ item, onEdit, onDelete, onAdjustStock }: DropdownActionsProps) => {
  const { t } = useTranslation('materialAlmacenModule');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="hover:bg-muted rounded-md p-1"
          data-testid={`dropdown-trigger-${item.id}`}
          onClick={(e) => e.stopPropagation()}
        >
          <FontAwesomeIcon icon={faEllipsisVertical} className="text-text" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44 border-card-border" data-testid={`dropdown-content-${item.id}`}>
        {onAdjustStock && (
          <DropdownMenuItem
            data-testid={`dropdown-adjust-stock-${item.id}`}
            onClick={(e) => {
              e.stopPropagation();
              onAdjustStock(item);
            }}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2 w-3.5" />
            {t('actions.adjust_stock')}
          </DropdownMenuItem>
        )}

        {onEdit && (
          <DropdownMenuItem
            data-testid={`dropdown-edit-${item.id}`}
            onClick={(e) => {
              e.stopPropagation();
              onEdit(item);
            }}
          >
            <FontAwesomeIcon icon={faPen} className="mr-2 w-3.5" />
            {t('button.edit')}
          </DropdownMenuItem>
        )}

        {onDelete && (
          <DropdownMenuItem
            data-testid={`dropdown-delete-${item.id}`}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(item);
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-2 w-3.5" />
            {t('button.delete')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
